import React from "react";
import { Progress } from "antd";
import NewLoader from "../../../../../../components/styled-components/loader/NewLoader";
export const TotalBudgetTile = ({
  monthsBudgetData,
  budgetData,
  categoryBudget,
  loading,
}) => {
  const totalCategorizedAmount =
    budgetData && budgetData.reduce((sum, item) => sum + item.amount, 0);
  const totalUncategorizedAmount =
    monthsBudgetData &&
    monthsBudgetData.reduce((sum, item) => sum + item.amount, 0);

  const totalBudgetValue = totalUncategorizedAmount + totalCategorizedAmount;
  const totalUsedAmount =
    categoryBudget &&
    categoryBudget.reduce((sum, item) => sum + item.usedAmount, 0);
  const totalLeftAmount =
    categoryBudget &&
    categoryBudget.reduce((sum, item) => sum + item.leftAmount, 0);

    const totalUncategorizedAmount1= totalUncategorizedAmount - totalCategorizedAmount;
    const totalBudgetValue1 = totalUncategorizedAmount ? totalUncategorizedAmount : 0;

  return (
    <div className="add-budget-tile" style={{ position: "relative" }}>
      <div className="categorized-budget-tile">
        <div className="total-budget-title">Total Budget</div>
        <div className="categorized-budget-container">
          <div className="categorized-budget-amount-box">
            <div className="categorized-budget-title">Total Categorized</div>
            <div className="categorized-budget-amount">{`$${
              totalCategorizedAmount
                ? totalCategorizedAmount
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : (0.0).toFixed(2)
            }`}</div>
          </div>
          <div className="categorized-budget-amount-box">
            <div className="categorized-budget-title">Total Uncategorized</div>
            <div className="categorized-budget-amount">{`$${
              totalUncategorizedAmount1
                ? totalUncategorizedAmount1
                    .toFixed(2)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : (0.0).toFixed(2)
            }`}</div>
          </div>
        </div>
      </div>
      <p style={{ margin: "0px" }}>
        <span className="cardTotalAmount">
          $
          {totalBudgetValue1 && totalBudgetValue1 !== undefined
            ? `${totalBudgetValue1
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
            : (0.0)
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}{" "}
        </span>
        <span className="totalStyle"> Total </span>
      </p>
      <Progress
        type="line"
        strokeColor={
          totalLeftAmount &&
                (totalLeftAmount + (totalUncategorizedAmount1
                  ? totalUncategorizedAmount1
                  : 0)) < (totalUsedAmount && totalUsedAmount)
                  ? "#f5222d"
                  : "#2a3da3"
        }
        // strokeColor={"#2a3da3"}
        trailColor="#333533"
        // percent={46}
        percent={
          totalBudgetValue1 && totalUsedAmount
          ? ((totalUsedAmount / totalBudgetValue1) * 100).toFixed(2) // Optional: Round to 2 decimal places
          : 0
        }
        style={{ marginTop: "1rem" }}
        showInfo={false}
      />
      <div className="progressLabelCotainer">
        <div className="progressLabelMain">
          <div
            className="progressBox"
            style={{
              // background: "#2a3da3",
              background:
                totalLeftAmount &&
                (totalLeftAmount + (totalUncategorizedAmount1
                  ? totalUncategorizedAmount1
                  : 0)) < (totalUsedAmount && totalUsedAmount)
                  ? "#f5222d"
                  : "#2a3da3",
            }}
          ></div>
          <div className="progressLabel">
            Used{" "}
            <p>
              {`$${
                totalUsedAmount
                  ? totalUsedAmount
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0.0
              }`}
            </p>
          </div>
        </div>
        <div className="progressLabelMain">
          <div
            className="progressBox"
            style={{
              backgroundColor: "#f5f5f5",
            }}
          ></div>
          <div className="progressLabel">
            Left{" "}
            <p>
              {`$${
                totalLeftAmount
                  ? (totalLeftAmount + (totalUncategorizedAmount1
                      ? totalUncategorizedAmount1
                      : 0)
                    )
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0.0
              }`}
            </p>
          </div>
        </div>
      </div>
      <NewLoader isLoading={loading} />
    </div>
  );
};
